<!--
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: NotFind
 * @Description: 404页面
 * @FilePath: /app-tikfriend_web/src/pages/content/NotFind.vue
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-08-16 10:21:42
 * @LastEditors: 谢洪培 446245520@qq.com
 * @LastEditTime: 2022-05-07 18:28:10
 * @example: 调用示例
-->
<template>
  <div class="home">
    <nav-bar @handlerLi="gotoPage" />
    <section class="container-x">
      <div class="main-x">
        <div class="notfind-x">
          <img src="@/assets/empty.png" alt="404" />
          页面不存在
        </div>
      </div>
    </section>
    <footer-bar :describeData="contentData.id" />
  </div>
</template>

<script>
  import NavBar from '@/components/NavBar.vue'
  import FooterBar from '@/components/FooterBar.vue'
  import Home from '@/pages/content/Home.vue'
  import Team from '@/pages/content/Team.vue'
  import Download from '@/pages/content/Download.vue'
  import JoinUs from '@/pages/content/JoinUs.vue'
  export default {
    name: 'NotFind',
    components: {  NavBar, FooterBar, Home, Team, Download, JoinUs },
    data () {
    return {
      curPage: '',
      contentData: this.$api.Index_item[0],
    }
  },
  methods: {
    gotoPage(item) {
      var that = this
      console.log("========>")
      if(item.compName == 'home' || item.compName == 'team' || item.compName == 'joinus') {
        this.$router.push('/' + item.compName)
      } else if(item.compName == 'chat' || item.compName == 'work' || item.compName == 'goudrive') {
        this.$router.push('/' + item.compName)
        this.contentData = this.$api.Index_item.find(x => x.compName == item.compTitle)
      }
    }
  }
}
</script>
